import { Controller } from "@hotwired/stimulus"

// Universal focus controller — focuses the first matching input whenever the element becomes visible.
//
// Handles three scenarios automatically:
//   1. Initial page/frame load (connect)
//   2. Turbo Frame update (turbo:frame-load)
//   3. Bootstrap modal open (shown.bs.modal)
//
// Usage:
//   data-controller="focus-on"
//
// Optional values:
//   data-focus-on-selector-value="input.my-field"   — CSS selector for the target element
//                                                      (default: first [autofocus], then first visible input/textarea)
export default class extends Controller {
  static values = {
    selector: { type: String, default: "" }
  }

  connect() {
    this._handler = () => this.focus()
    this.element.addEventListener("turbo:frame-load", this._handler)
    this.element.addEventListener("shown.bs.modal", this._handler)
    this.focus()
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this._handler)
    this.element.removeEventListener("shown.bs.modal", this._handler)
  }

  focus() {
    const selector = this.selectorValue ||
      "[autofocus], input:not([type=hidden]):not([tabindex='-1']), textarea:not([tabindex='-1'])"
    const input = this.element.querySelector(selector)
    if (input) {
      input.focus()
      input.select?.()
    }
  }
}
